import { useEffect, useState } from 'preact/hooks';

import { Loader, Footer, Header } from '../components';
import { post } from '../utils/http';

import * as styles from './proof.module.css';

// Keys this browser has personally reported — kept locally so a reporter never
// has to see (or re-report) the image again, independent of the global counter.
const STORE = 'prooveit-reported';
const loadReported = () => {
  try {
    return JSON.parse(localStorage.getItem(STORE) || '[]');
  } catch (e) {
    return [];
  }
};

export default function Proof({ code }) {
  const [images, setImages] = useState([]);
  const [revealed, setRevealed] = useState({});
  const [reported, setReported] = useState(() => new Set(loadReported()));

  useEffect(async () => {
    const response = await post('/images', { code });
    setImages((response && response.images) || []);
  }, [code]);

  function report(idx, key) {
    // Hide it for this user right away + remember across visits.
    setReported((prev) => {
      const next = new Set(prev);
      next.add(key);
      try {
        localStorage.setItem(STORE, JSON.stringify([...next]));
      } catch (e) {
        /* ignore storage errors */
      }
      return next;
    });
    setRevealed((r) => {
      const c = { ...r };
      delete c[idx];
      return c;
    });
    // Bump the global counter (fire and forget).
    post('/report', { key });
  }

  return (
    <>
      <Header />
      {images.length < 1 ? (
        <main class={styles.loading}>
          <Loader />
        </main>
      ) : (
        images.map((i, n) => {
          const isReported = reported.has(i.key);
          const covered = (i.hidden || isReported) && !revealed[n];
          const style = {
            backgroundImage: `url(${i.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          };

          return (
            <article class={styles.proof}>
              <div>
                <h3>Exhibit {n + 1}</h3>
                <div class={styles.imageWrap}>
                  <a
                    class={covered ? `${styles.image} ${styles.blurred}` : styles.image}
                    href={covered ? undefined : i.url}
                    style={style}
                  >
                    &nbsp;
                  </a>
                  {covered && (
                    <button
                      type="button"
                      class={styles.pillowcase}
                      onClick={() =>
                        setRevealed((r) => ({ ...r, [n]: true }))
                      }
                    >
                      <span class={styles.pillowTitle}>Get the pillowcase!</span>
                      <span class={styles.pillowSub}>
                        This image was marked inappropriate. Click to view anyway.
                      </span>
                    </button>
                  )}
                </div>
                {!isReported && (
                  <a class={styles.report} onClick={() => report(n, i.key)}>
                    Mark this image as inappropriate.
                  </a>
                )}
              </div>
            </article>
          );
        })
      )}
      <Footer />
    </>
  );
}
